"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./ContentWithHeaderLayoutTemplate.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * This is layout for following case:
 *  ___________________________
 * | {header}                  |
 * |___________________________|
 * |                           |
 * | {content}                 |
 * |                           |
 * |___________________________|
 */
var ContentWithHeaderLayoutTemplate = function ContentWithHeaderLayoutTemplate(props) {
  var children = props.children,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    header = props.header;
  var baseLayoutTemplateClasses = (0, _cssClassesHelper.getBEMClasses)('base-lt', customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseLayoutTemplateClasses('layout-template', classModifiers)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseLayoutTemplateClasses('header', classModifiers)
  }, header), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseLayoutTemplateClasses('body', classModifiers)
  }, children));
};
ContentWithHeaderLayoutTemplate.propTypes = {
  children: _propTypes["default"].element.isRequired,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].element]).isRequired
};
ContentWithHeaderLayoutTemplate.defaultProps = {
  customClass: 'custom-retail-widget'
};
var _default = exports["default"] = ContentWithHeaderLayoutTemplate;